module.exports = __webpack_public_path__ + "static/media/MasjidBaitusSlam.fc1009af.png";